import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './DataTable.module.css';
import Spinner from '@/components/ui/Spinner';
import EmptyState from '@/components/ui/EmptyState';

/**
 * Tabela genérica.
 * columns = [{ key, header, render?(row), width?, align? }]
 * rows = array de objetos. rowKey(row) → id.
 */
export default function DataTable({
  columns,
  rows,
  rowKey = (r) => r.id,
  loading,
  empty,
  onRowClick,
}) {
  const { t } = useTranslation();
  if (loading) {
    return (
      <div className={styles.center}>
        <Spinner />
      </div>
    );
  }
  if (!rows || rows.length === 0) {
    return empty || <EmptyState title={t('screens.noData')} />;
  }

  return (
    <div className={styles.scroll}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} style={{ width: c.width, textAlign: c.align || 'left' }}>
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={rowKey(row)}
              className={clsx(onRowClick && styles.clickable)}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
            >
              {columns.map((c) => (
                <td key={c.key} style={{ textAlign: c.align || 'left' }}>
                  {c.render ? c.render(row) : row[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
